<template>
    <div class="page__content payments">
        <div class="columns">
            <div class="column is-8">
                <h2 class="page__headline">{{ $t('payments.headline') }}</h2>
                <p class="page__copy" v-html="$t('payments.copy', { 'min_payment_age': minPaymentAge - 1, 'threshold': thresholdFormatted })"></p>
            </div>
        </div>
        <payment-list></payment-list>
    </div>
</template>

<script>
import {Api} from '../../../api';
import {AppModel} from '../../../models';
import {PaymentList} from '../../components';
import filters from '../../../filters';

export default {
    name: 'payments',
    components: {
        PaymentList
    },
    data() {
        return {
            campground: null,
            minPaymentAge: 0,
            payoutThreshold: 0,
        };
    },
    beforeRouteEnter(to, from, next) {
        Api.bootstrap().then(function(response) {
            return Promise.all([response, Api.payouts.fetch()]);
        }).then(function(response) {
            next((vm) => {
                vm.onPayoutsFetched(response[1].body);
            });
        });
    },
    computed: {
        lang() {
            return AppModel.lang;
        },

        thresholdFormatted() {
            return filters.currency(this.payoutThreshold, this.$getDefaultCurrency().code, this.lang);
        },
    },
    methods: {
        onPayoutsFetched(data) {
            AppModel.setPendingPayoutData(data);
            if(AppModel.activeCampground) {
                this.minPaymentAge = AppModel.minPaymentAge;
                this.payoutThreshold = AppModel.activeCampground.settings.payout_threshold;
            }
        }
    },
};
</script>
<style lang="scss">
    @import 'payments.scss';
</style>



// WEBPACK FOOTER //
// src/views/pages/payments/payments.vue